'use client';

import { PricingCard } from '@/components/pricing/PricingCard';
import { STRIPE_PRODUCTS } from '@/stripe-config';

export default function PricingPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-12">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Choose Your Plan
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Get the coins you need to power your interview practice sessions
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {STRIPE_PRODUCTS.map((product, index) => (
            <PricingCard 
              key={product.id} 
              product={product} 
              isPopular={index === 1} 
            />
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-sm text-gray-500">
            All subscriptions can be cancelled at any time. No hidden fees.
          </p>
        </div>
      </div>
    </div>
  );
}